import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const EyeSlashIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.35331 9.79767C9.89793 9.38703 10.25 8.73463 10.25 8C10.25 6.75736 9.24264 5.75 8 5.75C7.26537 5.75 6.61297 6.10207 6.20233 6.64669L7.29612 7.74048C7.40172 7.45416 7.67702 7.25 8 7.25C8.41422 7.25 8.75 7.58579 8.75 8C8.75 8.32299 8.54584 8.59829 8.25952 8.70389L9.35331 9.79767Z"
      fill="currentColor"
    />
    <path d="M2 2L14 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.1824 5.59666C1.63734 6.05011 1.20854 6.48368 0.913545 6.80601C0.36593 7.40438 0.352817 8.29876 0.875859 8.9142C1.67588 9.85553 3.51954 11.7445 6.03245 12.4634C7.00985 12.7431 8.08731 12.8451 9.23286 12.6471L7.83196 11.2462C7.34937 11.2283 6.88642 11.1476 6.44506 11.0213C4.36764 10.4269 2.76346 8.81896 2.01884 7.94281C1.9975 7.9177 1.99271 7.89553 1.99299 7.8793C1.99326 7.86322 1.99864 7.84214 2.02009 7.81871C2.30994 7.502 2.7265 7.08575 3.24817 6.66242L2.1824 5.59666ZM10.2231 10.8089C11.3511 10.3509 12.5883 9.48772 13.8957 8.00873C13.9596 7.93651 13.9559 7.82251 13.8928 7.75615C12.4427 6.23081 11.076 5.40971 9.84337 5.02803C8.61419 4.64742 7.47423 4.68994 6.45085 4.96011C5.91863 5.10061 5.41758 5.30289 4.95404 5.53987L3.84784 4.43367C4.50981 4.05502 5.25416 3.72464 6.06798 3.5098C7.33097 3.17637 8.75939 3.12212 10.287 3.59514C11.8112 4.06709 13.3898 5.05001 14.9799 6.72266C15.5824 7.35641 15.5955 8.35069 15.0196 9.00221C13.7879 10.3955 12.5607 11.3467 11.3567 11.9425L10.2231 10.8089Z"
      fill="currentColor"
    />
  </svg>
));
